<template>
  <div class="text-xs-center">


    <v-btn
      large
      fab
      dark
      bottom
      left
      fixed
      color="green"
      @click="addDrink"
      aria-label="add drink"
      :disabled="(defaultDrink==null)"
    >
      <v-icon>add</v-icon>
    </v-btn>

  </div>
</template>

<script>
  export default {
    name: 'addDrink',
    props: ['defaultDrink'],
    data() {
      return {}
    },
    methods: {
      addDrink() {
        this.$emit('addDrink');
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/otherComponents/addDrink.vue